import $ from "jquery";
import "waypoints/lib/jquery.waypoints";

let $body;

let $document;
let Creators_Page;

$document = require("../helpers/helpers").default.document;

$body = require("../helpers/helpers").default.body;

Creators_Page = (() => {
  function Creators_Page() {
    $document.ready(() => {
      console.log("CREATORS COFFEE");
      return $body.on("click", ".scroll-down", function(e) {
        let target;
        e.preventDefault();
        target = $(this).attr("href");
        return $("html, body").animate(
          {
            scrollTop: $(target).offset().top
          },
          500
        );
      });
    });
    $(".section-block").waypoint({
      handler: function() {
        console.log($(this));
        return $(this).addClass("in-view");
      },

      offset: "100%"
    });
  }

  return Creators_Page;
})();

export default Creators_Page;
